module.exports = __webpack_public_path__ + "img/step_m1.fda975c4.jpg";